import cn from "classnames";
import {useTranslation} from "react-i18next";
import {locales} from "../time";
import classes from "./datepicker.module.css";
import ReactDatePicker, {ReactDatePickerProps} from "react-datepicker";
import "./react-datepicker.css";

type props = ReactDatePickerProps & {};

export default function DatePicker({className: extraClassName, ...props}: props) {
  const {i18n} = useTranslation();

  const className = cn(classes.root, {}, extraClassName);
  const locale = locales[i18n.language] || locales["default"];

  return (
    <div>
      <ReactDatePicker className={cn(className, classes.root)} locale={locale} {...props} />
    </div>
  );
}
